import {observable, action} from 'mobx';

class SideBarStore {

  @observable isActive = false;

  @action
  activate = () => {
    this.isActive = !this.isActive;
  };

  @action
  deactivate = () => {
    this.isActive = false;
  };
}

export default new SideBarStore();



// WEBPACK FOOTER //
// ./src/stores/sidebarStore.js